// Pure validation for the /inquiry form — no DOM, so it's unit-testable without RTL.
export interface InquiryFormInput {
  name: string;
  email: string;
  message: string;
  /** 문의 현황 게시판에서 본인 글을 열 때 쓰는 조회 비밀번호. 선택이라 빈 값이면 통과해요. */
  viewPassword?: string;
}

export interface InquiryFormErrors {
  name?: string;
  email?: string;
  message?: string;
  viewPassword?: string;
}

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
/** api 의 view_password min_length 와 같은 값이에요 — 여기 검증은 UX 이고 신뢰 경계는 api 예요. */
export const VIEW_PASSWORD_MIN = 6;

export function validateInquiryForm(input: InquiryFormInput): InquiryFormErrors {
  const errors: InquiryFormErrors = {};

  if (!input.name.trim()) errors.name = "이름을 입력해 주세요.";

  const email = input.email.trim();
  if (!email) errors.email = "이메일을 입력해 주세요.";
  else if (!EMAIL_RE.test(email)) errors.email = "올바른 이메일 형식으로 입력해 주세요.";

  if (!input.message.trim()) errors.message = "문의 내용을 입력해 주세요.";

  // 선택 항목이라 빈 값은 통과 — 적었으면 길이만 봐요(공백만 적은 것도 비밀번호로 인정하지 않아요).
  const password = input.viewPassword ?? "";
  if (password && password.trim().length < VIEW_PASSWORD_MIN) {
    errors.viewPassword = `조회 비밀번호는 ${VIEW_PASSWORD_MIN}자 이상으로 정해 주세요.`;
  }

  return errors;
}
